import { GroupsView } from '@views';
import GroupViewModel from '../views/GroupView';
import { AdminGroupViewCreator } from './AdminGroupViewCreator';
import { Group } from '@models';
import apiResponse from '@stores/ApiResponse';
import { GroupStore } from '@stores';

export class AdminGroupsViewCreator {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  public async CreateView(): Promise<GroupsView> {
    await apiResponse.handleApiResponse(() => this.store.InvalidateCache());
    const groups = await apiResponse.handleApiResponse<Group[]>(() => this.store.AdminReadAll());
    const adminGroupViewCreator = new AdminGroupViewCreator();

    return {
      groups: groups.map((g: Group) => adminGroupViewCreator.CreateView(g)),
      selectedGroup: GroupViewModel.Empty,
      groupsUpdated: false,
      newGroup: GroupViewModel.Empty,
      editGroupModalVisible: false,
      newGroupModalVisible: false,
      participantsDialogVisible: false,
    };
  }
}
